import {AbstractControl, type ValidationErrors} from '@angular/forms';
import type {FormlyFieldConfig} from '@ngx-formly/core';

export function EmailValidator(control: AbstractControl): {[key: string]: any} | null {
  const value = control.value;
  if (!value) return null;

  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  return emailRegex.test(value) ? null : {email: true};
}

export function EmailValidatorMessage(_error: ValidationErrors, field: FormlyFieldConfig): string {
  const value = field?.formControl?.value ?? '';
  return value ? `"${value}" isn't a valid email address.` : 'Invalid email address.';
}
